import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  OnInit,
} from '@angular/core';
import { environment } from '../../../../environments/environment';
import {
  IResumenPoliza,
  IResumenColectivo,
} from 'src/app/shared/Entities/entities';
import { ProductService } from 'src/app/shared/services/product.service';
import { formateaRut, validaCorreo } from 'src/app/shared/helpers/helper';
import { NgForm, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { getErrorMessage } from 'src/app/shared/helpers/validationMessages';
import { from } from 'rxjs';
import * as bancos from 'src/app/shared/helpers/bancos.json';
import { PersonService } from '../../services/person.service';
import { MatDialog } from '@angular/material';
import { ErrorBannerComponent } from '../error-banner/error-banner.component';
import { DialogStatusMessageComponent } from '../dialog-status-message/dialog-status-message.component';
import { Router } from '@angular/router';
import { formatDate } from '@angular/common';
import { AuthService } from '../../services/auth.service';
import { FirmaModalComponent } from '../firma-modal/firma-modal.component';
import { DialogMessageModalComponent } from '../dialog-message-modal/dialog-message-modal.component';
import { statusEnum } from '../../helpers/constants';
import { timeout, delay } from 'rxjs/operators';
import { timer } from 'rxjs';
import { AppInsightsService } from '../../services/app-insights-service';
import { Event } from 'src/app/shared/enums/insights/event';
@Component({
  selector: 'app-rescates',
  templateUrl: './rescates.component.html',
  styleUrls: ['../../../../invStyles.sass', './rescates.component.sass'],
})
export class RescatesComponent implements OnInit, AfterViewInit {
  @Input() idPoliza: string;
  @Input() numPersona: string;
  @Input() tabActive: boolean;
  @Input() lineaNegocio: string;
  @Input() montoPesos: number;
  @Input() tipo: string;
  info: string =
    'Para actualizar el mail al cual recibirás la respuesta, ingresa a la sección "mis datos".';
  mostrarInfo: boolean = true;
  vidaUrl = environment.url.api + '/';
  mailUrl = environment.service.mail.endpoint_url;
  fileUrl = environment.service.file.endpoint_url;

  form: FormGroup;
  nombreContratante: string;
  rutContratante: string;
  nombreProducto: string;
  nCuentaDeposito: string;
  emailContratante: string;

  montoPesosValido = true;
  montoPesosVacioValido = true;
  resumen;
  loading = false;
  error = false;
  loadingService = false;
  UFActiva = true;
  valorRescatado;
  rescateParcial = true;
  tipoRescate = 'parcial';
  tipoDeposito = 'dbancario';
  depositoBancario = true;
  bancoSeleccionado = '0';
  cuentaSeleccionada = '0';
  bancos = bancos.default;
  tiposCuentas = environment.tiposCuentas;
  terminos = false;

  formularioSinProblemas = false;
  pierdeFocoTelefono = false;
  pierdeFocoMail = false;
  pierdeFocoNCuenta = false;
  pierdeFocoCuentas = false;
  pierdeFocoBancos = false;

  errorFormulario = false;

  emailDeposito: string;
  telDeposito: string;

  caseNumberSalesForce: string;

  correoVS = environment.correoVidaSecurity;
  url: string;

  constructor(
    private productService: ProductService,
    private personService: PersonService,
    private dialog: MatDialog,
    private router: Router,
    private authService: AuthService,
    private appInsightsService: AppInsightsService
  ) {
    this.url = this.router.url;
  }

  ngOnInit() {
    this.loading = true;
    this.error = false;

    this.appInsightsService.trackEvent(Event.iidrInitRescue);

    this.limpiarFormulario();

    switch (this.lineaNegocio) {
      case 'PF':
        const getDescargaPolizaSubs = this.productService
          .getResumenColectivo(this.idPoliza)
          .subscribe(
            data => {
              this.loading = false;
              this.resumen = data;
              this.nombreContratante = data.RazonSocial;
              this.rutContratante = data.Rut + '-' + data.Dv;
              this.limpiarFormulario();
            },
            error => {
              this.loading = false;
              this.error = true;
              this.dialog.open(DialogStatusMessageComponent, {
                minWidth: '20vw',
                disableClose: true,
                data: {
                  title: 'Ha ocurrido un problema',
                  message: 'Intentelo de nuevo más tarde.',
                  error: true,
                },
              });
            }
          );
        break;
      case 'IND':
      case 'RRVV':
        const dataSubs = this.personService
          .getDatosContratanteProducto(
            this.idPoliza,
            this.lineaNegocio === 'IND' ? 'INDIVIDUAL' : 'RRVV',
            ''
          )
          .subscribe(
            data => {
              this.loading = false;
              this.nombreContratante = data.Nombre;
              this.rutContratante = data.Rut;
              this.emailContratante = data.Correo;
              this.emailDeposito = data.Correo;
              this.limpiarFormulario();
            },
            error => {
              this.loading = false;
              this.error = true;
              this.dialog.open(DialogStatusMessageComponent, {
                minWidth: '20vw',
                disableClose: true,
                data: {
                  title: 'Ha ocurrido un problema',
                  message: 'Intentelo de nuevo más tarde.',
                  error: true,
                },
              });
            }
          );
        break;
    }
  }

  ngAfterViewInit() {
    this.limpiarFormulario();
  }

  print() {
    if (this.error) {
      return null;
    }
    return this.resumen;
  }

  onSelectionChange() {
    this.rescateParcial = this.tipoRescate === 'parcial' ? true : false;
  }

  depositoSelectionChange() {
    this.depositoBancario = this.tipoDeposito === 'dbancario' ? true : false;
    this.bancos = bancos.default;
    this.tiposCuentas = environment.tiposCuentas;
    this.form = new FormGroup({
      banco: new FormControl(),
      cuentas: new FormControl(),
      terminos: new FormControl(),
      nCuentaDeposito: new FormControl(),
      rutContratante: this.form.get('rutContratante'),
      nombreContratante: this.form.get('nombreContratante'),
      emailDeposito: this.form.get('emailDeposito'),
      telDeposito: this.form.get('telDeposito'),
    });
  }

  toggleTipoRescate() {
    if (this.UFActiva === true) {
      this.UFActiva = false;
    } else {
      this.UFActiva = true;
    }
  }

  IsNumberValue(event) {
    return event.keyCode === 69 ||
      event.keyCode === 109 ||
      event.keyCode === 107
      ? false
      : true;
  }

  transformValue(event) {
    if (this.valorRescatado) {
      if (this.valorRescatado.split('.').join('').length > 9) {
        this.valorRescatado = parseInt(
          this.valorRescatado
            .split('.')
            .join('')
            .toString()
            .substring(0, 9),
          10
        );
      }
    }
  }

  onClick() {}

  onSubmit() {
    this.appInsightsService.trackEvent(Event.iidrBtnRequestRescue);
    this.postCasoSalesForce();
    return;
  }

  formatRUT(rut: string) {
    return formateaRut(rut);
  }

  onGetResumen(item: IResumenPoliza) {}

  bancoOnchange(event) {
    if (!event) {
      return;
    }
    this.bancoSeleccionado = event.value;
  }

  ///Este metodo ya no se usa.
  postCasoSalesForce() {
    this.loadingService = true;
    const banco = this.bancos.find(
      x => x.CodigoBanco === this.form.get('banco').value
    );
    const cuenta = this.tiposCuentas[this.form.get('cuentas').value - 1];
    console.log(this.form.get('cuentas').value - 1, cuenta, this.tiposCuentas);
    let pagoRescate =
      'Forma de Pago: ' +
      (this.tipoDeposito === 'dbancario'
        ? 'Depósito Bancario'
        : 'Vale Vista electrónico') +
      '\r\n';
    pagoRescate +=
      (this.UFActiva ? 'Monto' : 'Porcentaje') +
      ' rescate:' +
      this.valorRescatado +
      '\r\n';
    pagoRescate +=
      this.tipoDeposito === 'dbancario'
        ? 'Tipo de Cuenta: ' + (cuenta ? cuenta.Nombre : '') + '\r\n'
        : '';
    pagoRescate +=
      this.tipoDeposito === 'dbancario'
        ? 'Banco: ' + (banco ? banco.NombreBanco : '') + '\r\n'
        : '';
    pagoRescate +=
      this.tipoDeposito === 'dbancario'
        ? 'Número de cuenta: ' + (this.form.get('nCuentaDeposito').value || '')
        : '';

    const tipoMoneda = 'Monto en CLP';
    const detalleSolicitud = `ED - Solicitud de Rescate ${
      this.tipoRescate === 'parcial' ? 'Parcial' : 'Total'
    }`;
    // IBM - FSM : El detalle y el subject deben ser iguales.
    let subject = detalleSolicitud;
    const detalleRescate = `Rescate ${
      this.tipoRescate === 'parcial' ? 'Parcial' : 'Total'
    }`;

    const tipoSolicitante = 'Contratante';
    const casoCategoria = 'Siniestros/Rescates';
    return this.productService
      .postCasoSalesForceAmpliado(
        this.nombreContratante,
        this.rutContratante,
        this.emailContratante,
        this.form.get('telDeposito').value,
        subject,
        '',
        detalleRescate,
        tipoMoneda,
        pagoRescate,
        null,
        this.idPoliza,
        detalleSolicitud,
        null,
        tipoSolicitante,
        casoCategoria,
        this.emailDeposito
      )
      .subscribe(
        data => {
          this.loadingService = false;
          this.appInsightsService.trackEvent(Event.iidrCompleteRescueFinal);
          if (data.Codigo === 0) {
            this.formularioSinProblemas = true;
            this.errorFormulario = false;
            //this.productService.getCasoSalesForce(data.Requerimiento.Id)
            //.subscribe(dataCase => {
            const date = new Date();
            const dateStr = formatDate(date, 'dd/MM/yyyy', 'es-cl');
            // Type 5 parcial - Type 6 total
            const typeForm = this.tipoRescate === 'parcial' ? 5 : 6;
            const tipoRescate =
              this.tipoRescate === 'parcial' ? 'PARCIAL' : 'TOTAL';

            this.productService
              .postSendMail(
                data.Requerimiento.Id,
                typeForm,
                this.nombreContratante,
                dateStr,
                tipoRescate,
                this.idPoliza
              )
              .subscribe(
                () => {},
                () => {
                  this.loadingService = false;
                  this.formularioSinProblemas = false;
                  this.errorFormulario = true;
                  this.dialog.open(DialogStatusMessageComponent, {
                    minWidth: '20vw',
                    disableClose: true,
                    data: {
                      title: 'Ha ocurrido un problema',
                      message: 'Intentelo de nuevo más tarde.',
                      error: true,
                    },
                  });
                }
              );

            this.limpiarFormulario();
            timer(8000).subscribe(x => {
              this.formularioSinProblemas = false;
            });
            //});
          } else {
            this.errorFormulario = true;
          }
        },
        () => {
          this.appInsightsService.trackEvent(Event.iidrRescueError);

          this.loadingService = false;
          this.formularioSinProblemas = false;
          this.errorFormulario = true;
          this.dialog.open(DialogStatusMessageComponent, {
            minWidth: '20vw',
            disableClose: true,
            data: {
              title: 'Ha ocurrido un problema',
              message: 'Intentelo de nuevo más tarde.',
              error: true,
            },
          });
        }
      );
  }

  TerminosModificados() {
    if (this.form.get('terminos').value === false) {
      this.terminos = true;
    } else {
      this.terminos = false;
    }
  }
  getErrorMessage(form, field) {
    const campo = form.get(field);
    if (campo.value) {
      if (field === 'emailDeposito') {
        // tslint:disable-next-line:max-line-length
        if (!this.validaCorreo()) {
          return 'El correo ingresado no es válido.';
        }
      }
      if (field === 'nCuentaDeposito' || field === 'telDeposito') {
        if (!this.validarNumerico(field)) {
          return 'Ingrese un valor válido.';
        }
      }
    }
    return '';
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  limpiarFormulario() {
    this.depositoBancario = this.tipoDeposito === 'dbancario' ? true : false;
    this.bancos = bancos.default;
    this.tiposCuentas = environment.tiposCuentas;
    this.valorRescatado = null;
    this.pierdeFocoTelefono = false;
    this.pierdeFocoMail = false;
    this.pierdeFocoNCuenta = false;
    this.form = new FormGroup({
      banco: new FormControl(),
      cuentas: new FormControl(),
      nCuentaDeposito: new FormControl(),
      rutContratante: new FormControl(this.rutContratante),
      nombreContratante: new FormControl(this.nombreContratante),
      emailDeposito: new FormControl(this.emailDeposito),
      telDeposito: new FormControl(),
      terminos: new FormControl(false),
    });
  }

  validaCorreo() {
    const CorreoIsValid: boolean = validaCorreo(
      this.form.get('emailDeposito').value
    );
    if (CorreoIsValid) {
      this.form.get('emailDeposito').setErrors(null);
    } else {
      this.form.get('emailDeposito').setErrors({ incorrect: true });
    }
    return CorreoIsValid;
  }

  onFocus(field) {
    switch (field) {
      case 'montoPesos':
        this.valorRescatado = this.valorRescatado.replace(/\./g, '');
        break;
    }
  }

  onLostFocus(field) {
    switch (field) {
      case 'banco':
        this.pierdeFocoBancos = true;
        break;
      case 'cuentas':
        this.pierdeFocoCuentas = true;
        break;
      case 'nCuentaDeposito':
        this.pierdeFocoNCuenta = true;
        this.validarNumerico(field);
        break;
      case 'emailDeposito':
        this.pierdeFocoMail = true;
        this.validaCorreo();
        break;
      case 'montoPesos':
        this.processMyValue();
        const multiplo = parseFloat('0.85');

        const result = multiplo * this.montoPesos;
        // console.log(result,)
        if (Number(this.valorRescatado.split('.').join('')) > result) {
          this.montoPesosValido = false;
          this.montoPesosVacioValido = true;
        } else if (this.valorRescatado === '') {
          this.montoPesosVacioValido = false;
          this.montoPesosValido = true;
        } else {
          this.montoPesosValido = true;
          this.montoPesosVacioValido = true;
        }
        break;
      case 'telDeposito':
        this.pierdeFocoTelefono = true;
        this.validarNumerico(field);
        break;
    }
  }

  separadorDeMiles(numero) {
    return numero.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  validarNumerico(field) {
    if (this.form.get(field).value <= '0' || !this.form.get(field).value) {
      this.form.get(field).setErrors({ incorrect: true });
      return false;
    }
    if (field === 'telDeposito') {
      if (this.form.get(field).value.length !== 9) {
        this.form.get(field).setErrors({ incorrect: true });
        return false;
      }
    }
    this.form.get(field).setErrors(null);
    return true;
  }

  processMyValue(): void {
    // pone los puntos
    const txt = this.valorRescatado.replace(/\./g, '');
    if (Number(txt) > 0) {
      let numb = txt.match(/\d/g);
      numb = numb.join('');
      this.valorRescatado = parseInt(numb, 10).toLocaleString('da-DK');
    }
  }
}
